/**
 * Sortable Widget Component
 *
 * Wrapper that makes widgets sortable in edit mode.
 * Uses @dnd-kit/sortable for drag-and-drop reordering.
 *
 * @author BizClick WMS
 * @version 1.1.0
 */

import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { WidgetInstance } from '../types';

interface DraggableWidgetProps {
  widget: WidgetInstance;
  children: React.ReactNode;
}

const DraggableWidget: React.FC<DraggableWidgetProps> = ({ widget, children }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({
    id: widget.instanceId,
    data: {
      widget,
    },
  });

  const style: React.CSSProperties = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
    height: '100%',
    width: '100%',
    position: 'relative',
    zIndex: isDragging ? 1000 : 'auto',
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      {...attributes}
      {...listeners}
      className={`
        transition-shadow duration-200
        ${isDragging ? 'shadow-2xl' : ''}
      `}
    >
      {children}
    </div>
  );
};

export default DraggableWidget;
